// extracted by mini-css-extract-plugin
module.exports = {"container":"PageError_container__kTT5J","heading":"PageError_heading__pzfth","paragraph":"PageError_paragraph__zd5DJ"};